import { Injectable } from '@angular/core';

import { each } from 'lodash';
import { IFlag } from '../../../../ng2/shared/typings/interfaces/flags.interface';

interface IFlagsByCategory {
  academicFlags: IFlag[];
  attendanceFlags: IFlag[];
}
@Injectable()
export class FlagsFilterService {
  static $inject = [];

  constructor() {
    //
  }

  getFilteredFlags(flagData: IFlag[], cat: string): IFlag[] {
    const flags = [];
    each(flagData, (flag: IFlag) => {
      if (flag.category === cat && this.isActiveAndIgnored(flag)) {
        flags.push(flag);
      }
    });
    return flags;
  }

  getAllFlags(flagData: IFlag[]): IFlag[] {
    const flags = [];
    each(flagData, (flag: IFlag) => {
      if (this.isActiveAndIgnored(flag)) {
        flags.push(flag);
      }
    });
    return flags;
  }

  getAllFlagsByCategory(flagData: IFlag[]): IFlagsByCategory {
    const flags = {
      academicFlags: [],
      attendanceFlags: [],
    };
    each(flagData, (flag: IFlag) => {
      const isActiveAndIgnored = this.isActiveAndIgnored(flag);
      if (isActiveAndIgnored && flag.category === 'ACADEMIC') {
        flags.academicFlags.push(flag);
      }
      if (isActiveAndIgnored && flag.category === 'ATTENDANCE') {
        flags.attendanceFlags.push(flag);
      }
    });
    return flags;
  }

  isActive(flag: IFlag): boolean {
    const flagStatus = flag.status;
    return flagStatus === 'ACTIVE';
  }

  isIgnored(flag: IFlag): boolean {
    return flag.isIgnored;
  }

  isActiveAndIgnored(flag: IFlag): boolean {
    const isActive = this.isActive(flag);
    const isIgnored = this.isIgnored(flag);
    return isActive && !isIgnored;
  }
}
